<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">Aprobación de Despacho</v-toolbar-title>
                            <v-spacer></v-spacer>
                            EI 040
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> N° de Orden de Compra: {{ codoc }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Fecha de Orden de Compra: {{ fecha }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="8" md="10">
                                    <v-textarea dense v-model="descr" rows="2" auto-grow readonly outlined color="black"
                                        class="font-class-name"></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense v-model="cantidad" label="Cantidad de Entregas" outlined
                                        color="red darken-3"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Tarjeta para mostrar cada elemento -->
                    <v-card>
                        <v-card-text>
                            <v-row dense v-for="(item, index) in listado" :key="index">
                                <v-col cols="12" md="12">
                                    <v-card>
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="12" sm="2" md="2">
                                                    Entrega: {{ item.entrega }}
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    Item: {{ item.item }}
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    Camión: {{ item.camion }}
                                                </v-col>
                                                <v-col cols="12" sm="1" md="1">
                                                    Bultos: {{ item.bultos }}
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    Detalle Bultos
                                                    <v-textarea dense v-model="item.detallebultos" outlined rows="2"
                                                        auto-grow color="black" readonly
                                                        class="font-class-bulto"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-card color="#f2d7d5">
                                        <v-row dense>

                                            <v-col cols="12" sm="6" md="3">
                                                <h6><b> Transporte a cargo de ICSSA: </b></h6>
                                                <v-radio-group v-model="item.transporte" row dense>
                                                    <v-radio label="SI" value="SI"></v-radio>
                                                    <v-radio label="NO" value="NO"></v-radio>
                                                </v-radio-group>
                                                <h6><b> Seguro: </b></h6>
                                                <v-radio-group v-model="item.seguro" row dense>
                                                    <v-radio label="SI" value="SI"></v-radio>
                                                    <v-radio label="NO" value="NO"></v-radio>
                                                </v-radio-group>
                                                <h6><b> Descarga: </b></h6>
                                                <v-radio-group v-model="item.descarga" row dense>
                                                    <v-radio label="SI" value="SI"></v-radio>
                                                    <v-radio label="NO" value="NO"></v-radio>
                                                </v-radio-group>
                                                <v-text-field dense v-model="item.lugar" label="Lugar de Entrega"
                                                    outlined color="red darken-3"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="3">
                                                <h6><b> Remito: </b></h6>
                                                <v-radio-group v-model="item.remito" row dense>
                                                    <v-radio label="SI" value="SI"></v-radio>
                                                    <v-radio label="NO" value="NO"></v-radio>
                                                </v-radio-group>
                                                <h6><b> Nota de Envío: </b></h6>
                                                <v-radio-group v-model="item.nota" row dense>
                                                    <v-radio label="SI" value="SI"></v-radio>
                                                    <v-radio label="NO" value="NO"></v-radio>
                                                </v-radio-group>
                                                <h6><b> Factura: </b></h6>
                                                <v-radio-group v-model="item.factura" row dense>
                                                    <v-radio label="SI" value="SI"></v-radio>
                                                    <v-radio label="NO" value="NO"></v-radio>
                                                </v-radio-group>
                                                <v-text-field dense v-model="item.transpcliente"
                                                    label="Transporte usado por el Cliente" outlined
                                                    color="red darken-3"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="2">
                                                <v-text-field dense v-model="item.fecha" label="Fecha Necesidad (flete)"
                                                    outlined color="red darken-3"></v-text-field>
                                                <v-text-field dense v-model="item.montocarga"
                                                    label="Monto de la Carga (U$S)" outlined
                                                    color="red darken-3"></v-text-field>
                                                <v-text-field dense v-model="item.montoasegurar"
                                                    label="Monto a Asegurar (U$S)" outlined
                                                    color="red darken-3"></v-text-field>
                                                <h6>Póliza: {{ item.poliza }}</h6>
                                                <h6>Monto Asegurado: {{ item.montoasegurado }} + IVA</h6>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field dense v-model="item.detalleremito" label="Detalle Remito"
                                                    outlined color="red darken-3"></v-text-field>
                                                <v-text-field dense v-model="item.detallefactura"
                                                    label="Detalle Factura" outlined
                                                    color="red darken-3"></v-text-field>
                                                <v-text-field dense v-model="item.costoflete" label="Costo Flete"
                                                    outlined color="red darken-3"></v-text-field>
                                                <v-text-field dense v-model="item.costodescarga" label="Costo Descarga"
                                                    outlined color="red darken-3"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="2" md="4"></v-col>
                                            <v-col cols="12" sm="6" md="3">
                                                <v-select dense label="Estado Entrega" v-model="item.estado"
                                                    :items="estados" item-text="nombre" item-value="valor" outlined
                                                    class="font-class-name" color="black"></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select color="red darken-3" dense v-model="estado" :items="listadoestado"
                                        label="Estado" item-text="nombre" item-value="valor">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field color="red darken-3" required label="Enviar mail a:" dense
                                        v-model="direccion"></v-text-field>
                                </v-col>
                                <v-col cols="4" sm="1" md="1">
                                    <v-btn class="mx-2" @click="botonMail" dark small color="orange">
                                        <v-icon dark>
                                            mdi-arrow-left-bold
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-combobox color="red darken-3" dense v-model="correos" :items="direcciones"
                                        label="Listado mails" item-text="nombre" item-value="mail"></v-combobox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#d98880" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.font-class-bulto {
    font-size: 11px;
}
</style>
<style lang="scss" scoped>
.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;

    label {
        margin: 0 !important;
        margin-bottom: 0 !important;
    }

}

.v-textarea textarea {
    line-height: 0.5rem !important;
    margin: 1px;
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth";
export default {
    data() {
        return {
            valid: false,
            lazy: false,
            empresa: "",
            provision: "",
            descr: "",
            fecha: "",
            cantidad: "",
            tipo: "",
            listado: [{ id: "0", entrega: "1", item: "", camion: "", bultos: "", estado: "", detallebultos: "" },
            ],
            listadodespacho: [],
            estado: "",
            listadoestado: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            headers: [
                { text: "Entrega", value: "entrega", sortable: false, width: "5%" },
                { text: "Item", value: "item", sortable: false },
                { text: "Tipo y Cantidad de Camiones", value: "camion", sortable: false, width: "25%" },
                { text: "Total de Bultos", value: "bultos", sortable: false, width: "7%" },
                { text: "Estado", value: "estado", sortable: false, width: "15%" },

            ],
            deshabilitar: false,
            expanded: [],
            direcciones: [],
            direccion: "",
            correos: "",
            destinatarios: [],
            montoasegurado: "U$S 200.000,00",
            poliza: "01-03-12-30013068"
        };
    },

    props: ["visible", "codgral", "codoc"],
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListadoMail();
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    //this.$refs.form.resetValidation();
                    //document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },

    },
    watch: {
        cantidad() {
            this.actualizarDeshabilitar();
        },
        estado() {
            this.actualizarDeshabilitar();
        },
        listado: {
            handler() {
                this.actualizarDeshabilitar();
            },
            deep: true
        }
    },
    methods: {
        actualizarDeshabilitar() {
            const mensajes = [];

            const estadoPrincipal = (this.estado || "").trim().toUpperCase();
            const cantidadNumerica = Number(this.cantidad);
            const cantidadVacia = this.cantidad === "" || this.cantidad === null;

            const tieneEstadoDistintoDeP = this.listado.some(item => {
                const estadoItem = (item.estado || "").trim().toUpperCase();
                return estadoItem === "P" || estadoItem === "" || estadoItem === null;
            });

            const cantidadMayorQueListado = cantidadNumerica > this.listado.length;

            // Evaluamos todas las condiciones y guardamos los motivos
            if (cantidadVacia && estadoPrincipal === "C") {
                mensajes.push("* La cantidad no puede estar vacía si el estado es 'Cerrado'.");
            }

            if (estadoPrincipal === "C" && tieneEstadoDistintoDeP) {
                mensajes.push("* No puede Cerrar si alguna entrega no está en estado 'Cerrado'");
            }

            if (estadoPrincipal === "C" && cantidadMayorQueListado) {
                mensajes.push("* No puede Cerrar si la cantidad es mayor al número de entregas realizadas hasta el momento.");
            }

            // Lógica combinada
            if ((cantidadVacia && estadoPrincipal === "C") ||
                (estadoPrincipal === "C" && tieneEstadoDistintoDeP) ||
                (estadoPrincipal === "C" && cantidadMayorQueListado)) {
                this.deshabilitar = true;
                this.showAlert({
                    icon: "warning",
                    title: mensajes,
                    vm: this,
                });
            } else {
                this.deshabilitar = false;
            }
        },


        cargarListadoMail() {
            let self = this;
            axios
                .get("/Icssa/GetMail?")
                .then((response) => {
                    self.direcciones = response.data;
                })
                .catch((error) => {
                    self.direcciones = [];
                    console.log(error);
                });
        },
        botonMail() {
            this.direccion = this.direccion + this.correos.mail + ";";
        },
        cargardatos() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarAprobacion?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.empresa = response.data.empresa;
                    self.provision = response.data.provision;
                    self.fecha = response.data.fecha;
                    self.estado = response.data.estado;
                    self.cantidad = response.data.cantidad;
                    self.tipo = response.data.tipo;
                    self.descr = response.data.descr;
                    self.listado = response.data.despacho;

                    self.listado = self.listado.map(item => {
                        return {
                            ...item,
                            poliza: item.poliza || "01-03-12-30013068",
                            montoasegurado: item.montoasegurado || "200.000,00"
                        };
                    });
                    console.log("LISTADO ", self.listado)
                    //const entrega = self.listado.length + 1;
                    //if (self.listado.length == 0) {
                    //self.listado.push({ id: "0", entrega: entrega, item: "", camion: "", bultos: "", estado: "", detallebultos: "" },)
                    //}
                    //self.expanded = [0, 1, 2, 3, 4, 5, 6]
                    //self.setExpanded();
                }
                )
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Despacho",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.listado.forEach((element) => {
                        if ((element.detallebultos != "" && element.detallebultos != null) || (element.item != "" && element.item != null)) {
                            this.listadodespacho.push({
                                codgral: this.codgral,
                                codoc: this.codoc,
                                entrega: element.entrega,
                                transporte: element.transporte,
                                seguro: element.seguro,
                                descarga: element.descarga,
                                factura: element.factura,
                                nota: element.nota,
                                remito: element.remito,
                                lugar: element.lugar,
                                transpcliente: element.transpcliente,
                                detallefactura: element.detallefactura,
                                detalleremito: element.detalleremito,
                                costodescarga: element.costodescarga,
                                costoflete: element.costoflete,
                                fecha: element.fecha,
                                montoasegurar: element.montoasegurar,
                                montocarga: element.montocarga,
                                montoasegurado: element.montoasegurado,
                                poliza: element.poliza,
                                estado: element.estado,
                            });
                        }
                    });
                    var datos = {
                        codoc: this.codoc,
                        codgral: this.codgral,
                        empresa: this.empresa,
                        tipo: this.tipo,
                        estado: this.estado,
                        mail: this.direccion,
                        despachocom: this.listadodespacho,
                    };

                    let self = this;
                    axios
                        .post("/Lanzamiento/GuardarAprobacion", datos)
                        .then((response) => {
                            // self.$refs.form.resetValidation();
                            var data = response.data || {};

                            if (data.mailEnviado === false) {
                                self.$swal.fire({
                                    icon: "warning",
                                    title: "Planilla guardada",
                                    text:
                                        data.mensaje ||
                                        "La aprobación se registró correctamente, pero no se pudo enviar el mail de aviso.",
                                    background: "#ececec",
                                    confirmButtonText: "Entendido",
                                });
                            } else {
                                self.showAlert({
                                    icon: "success",
                                    title: "Planilla guardada con éxito",
                                    vm: self,
                                });
                            }
                            self.vaciarListado();
                            // setTimeout(() => {
                            //     this.$router.push({ name: "LanzamientoMain" });
                            // }, 7000);
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                            var msg = "No se pudo guardar la aprobación. Intente nuevamente.";
                            if (error.response && error.response.data && error.response.data.mensaje) {
                                msg = error.response.data.mensaje;
                            }
                            self.$swal.fire({
                                icon: "error",
                                title: "Error al guardar",
                                text: msg,
                                background: "#ececec",
                                confirmButtonText: "Cerrar",
                            });
                        });
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 7000,
            });
        },

        vaciarListado() {
            this.empresa = "";
            this.fecha = "";
            this.provision = "";
            this.descr = "";
            this.tipo = "";
            this.cantidad = "";
            this.listado = [];
            this.listadodespacho = [];
            this.estado = "";
            this.direccion = "";
            this.correos = "";
            this.direcciones = [];
            this.deshabilitar = false;

        },
    },
};
</script>
